import React from "react";
import * as S from "./about.style.ts";

const About = () => {
  return (
    <S.Wrapper>
      <div>
        At <strong>HeiPro Digital</strong>, we build a budget that answers the
        questions everyone actually has about their money — how long does my
        cash last, and what&apos;s safe to spend? Whether you&apos;re on a
        salary or you invoice for every dollar,{" "}
        <strong>Simple Budgeting</strong> is built around{" "}
        <strong>cash flow</strong>.
      </div>
      <S.Section>
        <S.Title>How It Started</S.Title>
        <div>
          We started with the people budgeting apps serve worst — freelancers,
          agency owners and solo consultants whose income arrives in uneven
          lumps. They kept asking the same three questions, and no app answered
          them well:
        </div>
        <ul>
          <li>
            <strong>How long does my cash actually last</strong> if the next
            payment slips?
          </li>
          <li>
            <strong>What can I safely pay myself</strong> this month without
            regretting it later?
          </li>
          <li>
            <strong>Which months are going to be lean</strong>, and am I ready
            for them?
          </li>
        </ul>
        <div>
          It turned out everyone wants those answers. So we made it work just as
          well for a steady paycheck — same tools, spoken as a plain monthly
          budget and an emergency fund.
        </div>
      </S.Section>

      <S.Section>
        <S.Title>Mission Statement</S.Title>
        <div>
          To give everyone the financial confidence a steady paycheck is
          supposed to buy — through{" "}
          <strong>an honest picture of your cash</strong>,{" "}
          <strong>real runway math</strong>, and a spending plan you can keep.
        </div>
        <div>We aim to:</div>
        <ul>
          <li>Tell you how long your cash actually lasts</li>
          <li>Show your lean months before they arrive</li>
          <li>Smooth lumpy income into a steady, predictable wage</li>
          <li>Keep tax money set aside so it&apos;s never a surprise</li>
        </ul>
      </S.Section>

      <S.Section>
        <S.Title>What Makes Simple Budgeting Different?</S.Title>
        <ul>
          <li>Cash-flow first — runway, not just a category list</li>
          <li>A cushion that absorbs your good and bad months</li>
          <li>A monthly number you can actually spend to</li>
          <li>Owner&apos;s pay and tax set-aside for the self-employed</li>
        </ul>
        <div>
          We&apos;re committed to keeping things simple, honest, and focused on
          the questions that actually keep people up at night.
        </div>
      </S.Section>
    </S.Wrapper>
  );
};

export default About;
